<div class="hearderPadding"></div>
<div class="container">
  <div [innerHtml]="settingsService.settings.termsAndConditions"></div>
</div>
